import { project } from './initializeStats.js';
import { statsArticle } from './statsArticle.js';
import { inViewport } from './elementsInViewport.js';
import { linkStats, setStatElementCollector, shareStats } from './stats.js';
import { wideo } from './wideo.js';
import { menu } from './menu.js';
import { anchors } from './anchors.js';
import { debounce } from './helpers.js';
import { accordion, resizeAccordion } from './widgets/accordeon.js';
import { beforeAfter } from './widgets/beforeAfter.js';
import { galleryHover } from './widgets/galleryHover.js';
import { sliderSwiperWindow, sliderSwiperWide } from './widgets/slider.js';
import { audioPlay } from './widgets/audio.js';
import { hotpoints } from './widgets/hotpoints.js';

anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
wideo();
menu();
accordion();
beforeAfter();
galleryHover();
sliderSwiperWindow();
sliderSwiperWide();
audioPlay();
hotpoints();
console.log("JS DZIALA");
console.log(typeof $);

let sendStats = function(){}

const changeSizesOnResize = () => {
  resizeAccordion();
};

window.addEventListener('resize', debounce(changeSizesOnResize, 500));

window.addEventListener('beforeunload', project.unloadData.bind(project));

// for testing
// document.querySelector('.header').addEventListener('click', project.unloadData.bind(project));

$('.owl-carousel').owlCarousel({       
  center: true,      
  loop: true,
  margin: 64,        
  responsive: {
    0: {
      items: 1
    },
    768: {
      items: 3
    },
    1024: {
      items: 3
    },
	1440: {
	  items: 5
	}
  }
});

if (document.querySelectorAll('.swiper.__ver_video').length) {
	document.querySelectorAll('.swiper.__ver_video').forEach((v) => {
		const videoSlider = v;
		const btnPrev = videoSlider.querySelector('.swiper-button-prev');
		const btnNext = videoSlider.querySelector('.swiper-button-next');

		//let swiperInstance = this;

		new Swiper('.swiper.__ver_video', {
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			spaceBetween: 50,
			navigation: {
				nextEl: btnNext,
				prevEl: btnPrev,
			},
			breakpoints: {
				1020: {
					slidesPerView: 1,
					spaceBetween: 90
				}
			},
			on: {
				'realIndexChange': (swiper) => {
					const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
					const eventCategory = swiper.el.dataset.ga360Id?swiper.el.dataset.ga360Id:'ERROR ga360';
					const artId = swiper.el.closest('.__js_stats_wrapper') ? swiper.el.closest('.__js_stats_wrapper').getAttribute('data-id') : 'ERROR No stats section';
					const dataId = swiper.el.dataset.id?swiper.el.dataset.id:'ERROR no id';
					const itemSource = swiper.el.querySelector('.player').dataset.url;
					
					sendStats(
						'gallery',
						eventAction,
						`${artId} / ${dataId}`,
						itemSource
					);

					WP.push(() => {
						WP.pwp.customAction({
						  ga: {
							event: 'content_interaction',
							eventCategory: eventCategory,
							moduleName: dataId,
							eventAction: eventAction						
						  },
						});
					  });
				}
			}
		});
	})
}